/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import FormativeAction from './FormativeAction';
import SubjectOfferItem from './SubjectOfferItem';

/**
 * The ArrayOfSubjectOfferItemsWithParent model module.
 * @module model/ArrayOfSubjectOfferItemsWithParent
 * @version 1.0
 */
class ArrayOfSubjectOfferItemsWithParent {
    /**
     * Constructs a new <code>ArrayOfSubjectOfferItemsWithParent</code>.
     * @alias module:model/ArrayOfSubjectOfferItemsWithParent
     */
    constructor() { 
        
        ArrayOfSubjectOfferItemsWithParent.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ArrayOfSubjectOfferItemsWithParent</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ArrayOfSubjectOfferItemsWithParent} obj Optional instance to populate.
     * @return {module:model/ArrayOfSubjectOfferItemsWithParent} The populated <code>ArrayOfSubjectOfferItemsWithParent</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ArrayOfSubjectOfferItemsWithParent();

            if (data.hasOwnProperty('parent')) {
                obj['parent'] = FormativeAction.constructFromObject(data['parent']);
            }
            if (data.hasOwnProperty('children')) {
                obj['children'] = ApiClient.convertToType(data['children'], [SubjectOfferItem]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/FormativeAction} parent
 */
ArrayOfSubjectOfferItemsWithParent.prototype['parent'] = undefined;

/**
 * @member {Array.<module:model/SubjectOfferItem>} children
 */
ArrayOfSubjectOfferItemsWithParent.prototype['children'] = undefined;






export default ArrayOfSubjectOfferItemsWithParent;

